import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HOME_ROUTE } from "../../../app/router/routes";
import { useGlobalMessageActions } from "../../../entities/globalMessage";

interface IAccessDeniedRedirectProps {
    to?: string;
    message?: string;
}

export const AccessDeniedRedirect: FC<IAccessDeniedRedirectProps> = ({
    to = HOME_ROUTE.path,
    message = 'Доступ запрещен',
}) => {
    const navigate = useNavigate()
    const {setGlobalMessage} = useGlobalMessageActions()

    useEffect(() => {
        setGlobalMessage({message, type: 'error'})
        navigate(to, {replace: true})
    }, [message, navigate, setGlobalMessage, to])

    return null
}
